module.exports = __webpack_public_path__ + "img/atlantis.deacb8d1.png";